<template>
  <div class="s-tabs">
        <router-link class="s-tab" v-for="tab in tabs" :key="tab.id" :to="{ name: tab.route }"
          :class="{ 'active-tab': ($route.name === tab.route) }">
          {{ tab.name }}
        </router-link>
      </div>
</template>

<script>


export default {
  props: {
    
  },
  data: () => ({
    tabs: [
      {
        id: 1,
        route: 'LiffMemberCardPartnetPoint',
        name: '異業點數交換'
      },
      {
        id: 2,
        route: 'LiffMemberCardPartnetPointLogs',
        name: '交換紀錄查詢'
      },
    ],
  }),
  computed: {

  },
}
</script>
<style lang="scss" scoped>
.s-tabs {
  display: flex;
  background-color: var(--s-white);
  position: sticky;
  top: 0;
  z-index: 10;
  justify-content: space-evenly;

  .s-tab {
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;

    color: var(--liff-tab_inactive_color) !important;



    // &.router-link-exact-active, &.active {
    //   border-bottom: 2px solid var(--liff-tab-color);
    //   color: var(--liff-tab-color);
    // }
  }

  a.active-tab {
    border-bottom: 4px solid #FE577F;
    color: #FE577F !important;
  }
}
</style>